
<template>
    <div>
        <vs-dialog v-model="active" prevent-close @close="borrarInfo">
            <template #header>
                <h4 class="not-margin">
                    Registrar familiar y/o tutor
                </h4>
            </template>

            <form autocomplete="off" @submit.prevent="postVincularFamiliar()">
                <div class="con-form">
                    <vs-alert v-if="correo_familiares.includes(correo)">
                        <template #title>
                            CORREO YA REGISTRADO
                        </template>
                        El correo que ingreso ya se encuentra registrado con otro usuario, y podría sobreescribirlo.
                    </vs-alert>
                    <vs-row :class="correo_familiares.includes(correo) ? 'mt-3' : ''">
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>Parentesco *</label>
                            <vs-select
                                class="pt-0"
                                placeholder="Parentesco" 
                                v-model="parentesco"
                            >
                                <vs-option label="Padre" value="padre">
                                    Padre
                                </vs-option>
                                <vs-option label="Madre" value="madre">
                                    Madre
                                </vs-option>
                                <vs-option label="Hermano/a" value="hermano">
                                    Hermano/a
                                </vs-option>
                                <vs-option label="Abuelo/a" value="abuelo">
                                    Abuelo/a
                                </vs-option>
                                <vs-option label="Tío/a" value="tio">
                                    Tío/a
                                </vs-option>
                                <vs-option label="Otro" value="otro">
                                    Otro
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('parentesco')">
                                    Requerido
                                </template>
                            </vs-select>
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>Apellido paterno *</label>
                            <vs-input
                                class="pt-0"
                                v-model="apellido_paterno"
                                placeholder="Apellido paterno"
                            >
                                <template #message-danger v-if="errorFields.includes('apellido_paterno')">
                                    Requerido
                                </template>
                            </vs-input>
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>Apellido materno *</label>
                            <vs-input
                                class="pt-0"
                                v-model="apellido_materno"
                                placeholder="Apellido materno"
                            >
                                <template #message-danger v-if="errorFields.includes('apellido_materno')">
                                    Requerido
                                </template>
                            </vs-input>
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>Nombre(s) *</label>
                            <vs-input
                                class="pt-0"
                                v-model="nombres"
                                placeholder="Nombre(s)"
                            >
                                <template #message-danger v-if="errorFields.includes('nombres')">
                                    Requerido
                                </template>
                            </vs-input>
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>Celular</label>
                            <vs-input
                                type="number"
                                class="pt-0"
                                v-model="celular"
                                placeholder="Celular"
                            />
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>Teléfono de casa</label>
                            <vs-input
                                type="number"
                                class="pt-0"
                                v-model="telefono_casa"
                                placeholder="Teléfono de casa"
                            />
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>Teléfono de trabajo</label>
                            <vs-input
                                type="number"
                                class="pt-0"
                                v-model="telefono_trabajo"
                                placeholder="Teléfono de trabajo"
                            />
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>Extensión</label>
                            <vs-input
                                type="number"
                                class="pt-0"
                                v-model="extension"
                                placeholder="Extensión"
                            />
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>Correo electrónico</label>
                            <vs-input
                                type="email"
                                class="pt-0"
                                v-model="correo"
                                placeholder="Correo electrónico"
                            >
                                <template #message-danger v-if="errorFields.includes('correo')">
                                    Requerido
                                </template>
                            </vs-input>
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>¿El alumno depende económicamente? *</label>
                            <vs-select
                                class="pt-0"
                                placeholder="¿El alumno depende económicamente?" 
                                v-model="el_alumno_depende"
                            >
                                <vs-option label="Si" value="si">
                                    Si
                                </vs-option>
                                <vs-option label="No" value="no">
                                    No
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('el_alumno_depende')">
                                    Requerido
                                </template>
                            </vs-select>
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>¿Trabaja? *</label>
                            <vs-select
                                class="pt-0"
                                placeholder="¿Trabaja?" 
                                v-model="trabaja"
                            >
                                <vs-option label="Si" value="si">
                                    Si
                                </vs-option>
                                <vs-option label="No" value="no">
                                    No
                                </vs-option>
                                <template #message-danger v-if="errorFields.includes('trabaja')">
                                    Requerido
                                </template>
                            </vs-select>
                        </vs-col>
                        <vs-col v-if="trabaja == 'si'" class="inputTitulo" sm="12" lg="4">
                            <label>Ocupación</label>
                            <vs-input
                                class="pt-0"
                                v-model="ocupacion"
                                placeholder="Ocupación"
                            />
                        </vs-col>
                        <vs-col v-if="trabaja == 'si'" class="inputTitulo" sm="12" lg="4">
                            <label>Empresa donde trabaja</label>
                            <vs-input
                                class="pt-0"
                                v-model="empresa_donde_trabaja"
                                placeholder="Empresa donde trabaja"
                            />
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                            <label>Último grado de estudios</label>
                            <vs-input
                                class="pt-0"
                                v-model="ultimo_grado_estudios"
                                placeholder="Último grado de estudios"
                            />
                        </vs-col>
                        <vs-col class="inputTitulo" sm="12" lg="4">
                             <vs-checkbox class="p-2" v-model="acceso_familiar">
                               ¿Crear acceso a familiar?
                            </vs-checkbox>
                        </vs-col>
                    </vs-row>
                </div>
        
                <div class="d-flex mt-4">
                    <div @click="borrarInfo()">
                        <div class="botonCancelar">
                            Cancelar
                        </div>
                    </div>
                    <vs-button
                        success
                        type="submit"
                        class="ml-auto"
                    >
                        Guardar
                    </vs-button>
                </div>
            </form>
        </vs-dialog>
    </div>  
</template>
<script>
import alumnos from '../../../../../api/requests/alumno'
export default {
    props:[
      'value',
      'general'
    ],
    data(){
        return{
            active: false,
            apellido_materno: '',
            apellido_paterno: '',
            celular: '',
            correo: '',
            el_alumno_depende: '',
            empresa_donde_trabaja: '',
            extension: '',
            nombres: '',
            ocupacion: '',
            parentesco: '',
            telefono_casa: '',
            telefono_trabajo: '',
            trabaja: '',
            ultimo_grado_estudios: '',
            acceso_familiar: false,
            errorFields: [],
            correo_familiares: []
        }
    },
    methods:{
        sanityForm () {
            this.errorFields = []
            if (!this.parentesco){
                this.errorFields.push('parentesco')
            }
            if (!this.apellido_paterno){
                this.errorFields.push('apellido_paterno')
            }
            if (!this.apellido_materno){
                this.errorFields.push('apellido_materno')
            }
            if (!this.nombres){
                this.errorFields.push('nombres')
            }
            if (!this.el_alumno_depende){
                this.errorFields.push('el_alumno_depende')
            }
            if (!this.trabaja){
                this.errorFields.push('trabaja')
            }
            if (!this.correo){
                this.errorFields.push('correo')
            }
            if (!this.errorFields.length){
                const params = {
                    apellido_materno: this.apellido_materno,
                    apellido_paterno: this.apellido_paterno,
                    celular: this.celular,
                    correo: this.correo,
                    el_alumno_depende: this.el_alumno_depende,
                    empresa_donde_trabaja: this.empresa_donde_trabaja,
                    extension: this.extension,
                    nombres: this.nombres,
                    ocupacion: this.ocupacion,
                    parentesco: this.parentesco,
                    persona_id: this.general.persona_id,
                    prospecto_id: this.general.prospecto_id,
                    telefono_casa: this.telefono_casa,
                    telefono_trabajo: this.telefono_trabajo,
                    trabaja: this.trabaja,
                    ultimo_grado_estudios: this.ultimo_grado_estudios,
                    crear_acceso: this.acceso_familiar
                }
                if(this.general.tipo != 'prospecto'){
                    params.prospecto_id = this.general.prospecto_id
                }else if(this.general.tipo == 'prospecto'){
                    params.prospecto_id = this.general.id
                }
                return params
            } else {
                return null
            }
        },
        async postVincularFamiliar(){
            if(this.sanityForm()){
                const loading = this.$vs.loading()
                try{
                    const {data: response} = await alumnos.postVincularFamiliar(this.sanityForm())
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        icon: '<i class="fas fa-check"></i>',
                        title: 'Operación éxitosa',
                        text: 'Se ha vinculado con éxito al familiar y/o tutor.'
                    })
                    loading.close()
                    this.$emit('refreshComponent')
                    this.borrarInfo()
                }catch{
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        duration: 5000,
                        position: null,
                        title: 'Algo salío mal',
                        text: 'Favor de comunicarse con el administrador'
                    })
                    loading.close()
                    this.borrarInfo()
                }
            }
        },
        borrarInfo(){
            this.apellido_materno = ''
            this.apellido_paterno = ''
            this.celular = ''
            this.correo = ''
            this.el_alumno_depende = ''
            this.empresa_donde_trabaja = ''
            this.extension = ''
            this.nombres = ''
            this.ocupacion = ''
            this.parentesco = ''
            this.general.persona_id = ''
            this.general.prospecto_id = ''
            this.telefono_casa = ''
            this.telefono_trabajo = ''
            this.trabaja = ''
            this.ultimo_grado_estudios = ''
            this.active = false
        },
        familiares(){
            if(this.general){
                this.correo_familiares = this.general.familiares.map(e => e.correo)
            }
        }
    },
    watch:{
    value (val) {
        this.active = val
    },
    active (val) {
        if (!val){
            this.$emit('input', val);
        }
    },
    general(){
        this.familiares()
    }
    }
}
</script>